import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { BASE_URL } from '../../api/baseURL';
import { axiosBaseQuery } from '../axiosBaseQuery';
import { PaginatedResponse, Response } from '../genericInterface';
import {
  ILifeStyle,
  ILifeStyleService,
  ILifeStyleEdit,
  ILifestyleUser
} from './interface';

export const lifeStyleApi = createApi({
  reducerPath: 'lifeStyleApi',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL
  }),
  tagTypes: ['lifeStyle', 'lifeStyleAgent'],
  endpoints: (builder) => ({
    addLifeStyleCategory: builder.mutation<Response<ILifeStyle>, FormData>({
      query: (payload) => ({
        url: '/lifestyle/category/add',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['lifeStyle']
    }),
    getAllLifestyleCategories: builder.query<
      PaginatedResponse<ILifeStyle>,
      void
    >({
      query: (query) => ({
        url: `/lifestyle/category/get-all`,
        method: 'GET'
      }),
      providesTags: ['lifeStyle']
    }),
    editLifestyleCategories: builder.mutation<
      Response<ILifeStyle>,
      ILifeStyleEdit
    >({
      query: (payload) => ({
        url: `/lifestyle/category/edit?id=${payload.id}`,
        method: 'PATCH',
        body: payload.body
      })
    }),
    getAllLifestyleServices: builder.query<
      PaginatedResponse<ILifeStyleService>,
      string | void
    >({
      query: (query) => ({
        url: `/lifestyle/service?categoryId=${query}`,
        method: 'GET'
      }),
      providesTags: ['lifeStyle']
    }),
    addLifeStyleService: builder.mutation<
      Response<ILifeStyleService>,
      FormData
    >({
      query: (payload) => ({
        url: '/lifestyle/service/add',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['lifeStyle']
    }),
    deleteLifestyleCategory: builder.mutation<Response<null>, string>({
      query: (payload) => ({
        url: `/lifestyle/category/delete?id=${payload}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['lifeStyle']
    }),
    getAllLifestyleAgent: builder.query<
      PaginatedResponse<ILifestyleUser>,
      void
    >({
      query: () => ({
        url: '/lifestyle/agent/get-all',
        method: 'GET'
      }),
      providesTags: ['lifeStyleAgent']
    }),
    editLifestyleAgentVerification: builder.mutation<
      Response<ILifestyleUser>,
      {
        agent: string;
        adminVerified: boolean;
      }
    >({
      query: (body) => ({
        url: '/lifestyle/agent/edit-verification',
        method: 'PATCH',
        body
      }),
      invalidatesTags: ['lifeStyleAgent']
    })
  })
});

export const {
  useAddLifeStyleCategoryMutation,
  useGetAllLifestyleCategoriesQuery,
  useGetAllLifestyleServicesQuery,
  useAddLifeStyleServiceMutation,
  useEditLifestyleCategoriesMutation,
  useDeleteLifestyleCategoryMutation,
  useGetAllLifestyleAgentQuery,
  useEditLifestyleAgentVerificationMutation
} = lifeStyleApi;
